module.exports = __webpack_public_path__ + "media/images/emblems/Urmein_wappen-f8aea414f5b18390ac2d210b7704b356.svg";